import { __assign } from "tslib";
import React from 'react';
import { DefaultOverride } from '../override';
import { ColumnItem } from '../column-item';
import { useConfig } from '../config-context';
import { ButtonMaxWidthElement } from './button-max-width-element';
import { ButtonMinWidthElement } from './button-min-width-element';
export function Button(props) {
    var _a = props.align, align = _a === void 0 ? 'center' : _a, _b = props.backgroundColor, backgroundColor = _b === void 0 ? '#414141' : _b, _c = props.border, border = _c === void 0 ? 'none' : _c, _d = props.borderRadius, borderRadius = _d === void 0 ? '3px' : _d, children = props.children, _e = props.color, color = _e === void 0 ? '#ffffff' : _e, cssClass = props.cssClass, _f = props.fontFamily, fontFamily = _f === void 0 ? 'Ubuntu, Helvetica, Arial, sans-serif' : _f, _g = props.fontSize, fontSize = _g === void 0 ? '13px' : _g, fontStyle = props.fontStyle, _h = props.fontWeight, fontWeight = _h === void 0 ? 'normal' : _h, height = props.height, href = props.href, _j = props.innerPadding, innerPadding = _j === void 0 ? '10px 25px' : _j, maxWidth = props.maxWidth, minWidth = props.minWidth, _k = props.padding, padding = _k === void 0 ? '10px 25px' : _k, rel = props.rel, _l = props.textDecoration, textDecoration = _l === void 0 ? 'none' : _l, width = props.width, override = props.override, overrideProps = props.overrideProps, onClick = props.onClick;
    var OverrideWith = override || DefaultOverride;
    var style = {
        display: 'inline-block',
        background: backgroundColor,
        color: color,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        lineHeight: '120%',
        margin: '0',
        textDecoration: textDecoration,
        textTransform: 'none',
        padding: innerPadding,
        msoPaddingAlt: '0px',
        borderRadius: borderRadius,
    };
    var config = useConfig();
    var ButtonMinWidth = config.implementations.ButtonMinWidth || ButtonMinWidthElement;
    return (React.createElement(ColumnItem, { align: align, padding: padding, cssClass: cssClass, verticalAlign: "middle" },
        React.createElement(OverrideWith, __assign({}, overrideProps),
            React.createElement(ButtonMaxWidthElement, { maxWidth: maxWidth },
                React.createElement("table", { border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: {
                        width: width,
                        borderCollapse: 'separate',
                        lineHeight: '100%',
                    }, width: width },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { align: "center", bgcolor: backgroundColor === 'none' ? undefined : backgroundColor, role: "presentation", style: {
                                    border: border,
                                    borderRadius: borderRadius,
                                    cursor: 'auto',
                                    fontStyle: fontStyle,
                                    height: height,
                                    msoPaddingAlt: innerPadding,
                                    background: backgroundColor,
                                }, valign: "middle", onClick: onClick },
                                href ? (React.createElement("a", { href: href, rel: rel, style: style, target: "_blank" }, children)) : (React.createElement("p", { style: style }, children)),
                                React.createElement(ButtonMinWidth, { minWidth: minWidth })))))))));
}
//# sourceMappingURL=button.js.map